import { ROUTES } from '#/config/routes';
import { DocumentStatusBadge } from '#/modules/commonComponents/badge/DocumentStatusBadge';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import { formatDateOrDash } from '#/utils/date';

import PurchaseOrderInboundPreviewCell from '#/modules/srmMgmt/purchaseOrder/components/PurchaseOrderInboundPreviewCell';

function displayDash(value) {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
}

function formatWarehouseLabel(warehouse) {
  if (!warehouse) {
    return '—';
  }
  const label = [warehouse.code, warehouse.name].filter(Boolean).join(' ');
  return label || '—';
}

export function buildPurchaseOrderInboundColumns({
  purchaseOrderId,
  onMutated,
} = {}) {
  return [
    {
      id: 'actions',
      header: '操作',
      size: 160,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <PurchaseOrderInboundPreviewCell
          receiptId={row.original.id}
          receiptStatus={row.original.status}
          purchaseOrderId={purchaseOrderId}
          onMutated={onMutated}
        />
      ),
    },
    {
      id: 'receiptNo',
      header: '入庫單號',
      accessorFn: (row) => displayDash(row.receiptNo),
      size: 150,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const receiptId = row.original.id;
        return (
          <TruncatedTextWithTooltip
            text={displayDash(row.original.receiptNo)}
            detailPath={
              receiptId ? ROUTES.stockReceiptDetail(receiptId) : null
            }
            tooltipContent={
              receiptId ? '雙擊開啟單據（新分頁）' : null
            }
          />
        );
      },
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 110,
      enableSorting: false,
      cell: ({ row }) => (
        row.original.status
          ? <DocumentStatusBadge status={row.original.status} size="sm" />
          : '—'
      ),
      meta: { statusPresentation: 'badge' },
    },
    {
      id: 'receiptDate',
      header: '入庫日',
      accessorFn: (row) => formatDateOrDash(row.receiptDate),
      size: 120,
      enableSorting: false,
    },
    {
      id: 'warehouse',
      header: '倉別',
      accessorFn: (row) => formatWarehouseLabel(row.warehouse),
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
    },
  ];
}
